import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "tabButton", "checkbox"]

  connect() {
    console.log("moreOptions connect")

    // this.tabTargets[0].toggleTransition()
  }

  toggleMoreOptions(event) {
    console.log(event)
    this.tabTargets.forEach(card => {
      console.log(card.id)
      if (card.id === event.params.id) {
        card.classList.remove("hidden")
      } else {
        card.classList.add("hidden")
      }
    })

    this.tabButtonTargets.forEach(button => {
      console.log(button.dataset.cardsIdParam)
      if (button.dataset.cardsIdParam === event.params.id) {
        button.classList.add("font-medium", "border-blue-500", "text-blue-500")
        button.classList.remove("border-gray-200", "text-gray-400")
      } else {
        button.classList.remove("font-medium", "border-blue-500", "text-blue-500")
        button.classList.add("border-gray-200", "text-gray-400")
      }
    })

    this.checkboxTarget.checked = !this.checkboxTarget.checked
    this.checkboxTarget.value = this.checkboxTarget.checked ? "1" : "0"
  }
}
